"use client";

import AdmissionsModal from "@/components/AdmissionModal";
import { About } from "@/components/landing/about";
import { Contact } from "@/components/landing/contact";
import { Gallery } from "@/components/landing/gallery";
import { Hero } from "@/components/landing/hero";
import { Program } from "@/components/landing/program";
import { Testimonial } from "@/components/landing/testimonial";
import { useEffect, useState } from "react";

export default function Home() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    // Small delay so it pops up nicely after page load
    const timer = setTimeout(() => setIsModalOpen(true), 1500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <div>
        <Hero />
        <About />
        <Program />
        <Gallery />
        <Testimonial />
        <Contact />
        <AdmissionsModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />
      </div>
    </>
  );
}
